import { render, staticRenderFns } from "./MediaPreviewPopup.vue?vue&type=template&id=09fb7127"
import script from "./MediaPreviewPopup.vue?vue&type=script&lang=ts"
export * from "./MediaPreviewPopup.vue?vue&type=script&lang=ts"
import style0 from "./MediaPreviewPopup.vue?vue&type=style&index=0&id=09fb7127&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports